import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'cms-icon-signal',
  shadow: false,
})
export class CmsIconSignal {
  /**
   * Define the color used to paint the svg element.
   */
  @Prop() dataFill: string = 'currentColor';
  /**
   * The width of the svg element.
   */
  @Prop() dataWidth: string | number = null;

  /**
   * The height of the svg element.
   */
  @Prop() dataHeight: string | number = null;

  render() {
    return (
      /*@ts-ignore*/
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 20 20"
        focusable="false"
        aria-hidden="true"
        fill-rule="evenodd"
        clip-rule="evenodd"
        width={this.dataWidth}
        height={this.dataHeight}
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4 13C2.344 13 1 14.3447 1 16C1 17.6553 2.344 19 4 19C5.656 19 7 17.6553 7 16C7 14.3447 5.656 13 4 13ZM4 7C4 7 2.5 7.04688 2.5 8.5C2.5 9.95312 4 10 4 10C7.31348 10 10 12.6865 10 16C10 16 10 17.5 11.5 17.5C13 17.5 13 16 13 16C13 11.0312 8.96948 7 4 7ZM4 1C4 1 2.5 1 2.5 2.5C2.5 4 4 4 4 4C10.627 4 16 9.37305 16 16C16 16 16 17.5 17.5 17.5C19 17.5 19 16 19 16C19 7.71705 12.2852 1 4 1Z"
          fill={this.dataFill}
        />
      </svg>
    );
  }
}
